import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { BehaviorSubject, Observable } from 'rxjs';
import { ThemeService } from '../service/theme.service';
import moments from 'moment';
import { throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private principalURL = environment.apiUrl;
  private currentUserRole = new BehaviorSubject<string | null>(null);

  constructor(private http: HttpClient,
    private themeService: ThemeService
  ) { }

logInUser(user: any) {
  return this.http.post<any>(`${this.principalURL}/auth`, user).pipe(
    map(response => {
      const token = response.jwtToken;
      const role  = response.ROL;
      const style = response.ESTILO;

      localStorage.setItem('token', token);
      localStorage.setItem('role', String(role));
      localStorage.setItem('userStyle', style);

      this.currentUserRole.next(role);
      this.themeService.reloadTheme();  // Recarga el tema

      return response; 
    })
  );
}


  isLogged(){
    return !!localStorage.getItem('token')
  }

  logOutUser()
  {
    localStorage.clear();
  }

  getMaterias()
  {
    return this.http.get<any>(`${this.principalURL}/case/materia`)
  }

  // Materias que el usuario puede CREAR. El backend filtra a solo Mediación si el
  // usuario tiene el permiso case.create.solo_mediacion. Usar solo en formularios
  // de creación de casos; el resto de vistas sigue usando getMaterias().
  getMateriasCreables()
  {
    return this.http.get<any>(`${this.principalURL}/case/materia/creables`)
  }

  createCliente(client: any)
  {
    return this.http.post<any>(`${this.principalURL}/client/create`, client)   
  }
  getClientes()
  {
    return this.http.get<any>(`${this.principalURL}/client`)   
  }



  createCausas(caso:any)
  {
    return this.http.post<any>(`${this.principalURL}/case/create`, caso)
  }
  getAsesoriasDisponibles()
  {
    return this.http.get<any[]>(`${this.principalURL}/case/asesorias-disponibles`)
  }
  getCausas()
  {
    return this.http.get<any>(`${this.principalURL}/case`)   
  }
  getCausasEtapa(ETAPA: any)
  {
    return this.http.post<any>(`${this.principalURL}/case/status`, {ETAPA})   
  }

  getCausaByID(idCaso: any) {
    return this.http.post<any>(`${this.principalURL}/case`, { idCaso })
        .pipe(
            map(caso => {
                // Aquí debería mostrar la fecha y la hora si es que están presentes
                if (caso.FECHA_INICIO) caso.FECHA_INICIO = moment.tz(caso.FECHA_INICIO, 'America/Santiago').toDate();
                if (caso.FECHA_FIN) caso.FECHA_FIN = moment.tz(caso.FECHA_FIN, 'America/Santiago').toDate();
                if (caso.AUDIENCIA_FECHA) caso.AUDIENCIA_FECHA = moment.tz(caso.AUDIENCIA_FECHA, 'America/Santiago').toDate();
                if (caso.ULTIMA_ACTUALIZACION) caso.ULTIMA_ACTUALIZACION = moment.tz(caso.ULTIMA_ACTUALIZACION, 'America/Santiago').toDate();
                caso.AUDIENCIA_HORA = moments(caso.AUDIENCIA_HORA).toDate();
                return caso;
            }),
            catchError(err => {
                return throwError(() => new Error('Error fetching case data'));
            })
        );
}



getCausaByClient(CLIENTE_ID:any)
{
  return this.http.post<any>(`${this.principalURL}/case/client`, {CLIENTE_ID})   
}

getCausaByEmployee(EMPLOYEE_ID:any)
{
  return this.http.post<any>(`${this.principalURL}/case/employee`, {EMPLOYEE_ID})
}

// Reasignar casos + pagos pendientes de un abogado a otro. dryRun:true = vista previa.
reasignarCasos(payload: { empleadoOrigenId: any; empleadoDestinoId: any; casoIds?: any[]; dryRun?: boolean })
{
  return this.http.post<any>(`${this.principalURL}/case/reassign`, payload)
}

updateClient(CLIENTE_ID: any, changes :any)
{
  return this.http.post<any>(`${this.principalURL}/client/update`, {CLIENTE_ID, changes })   
}

  updateCausa(idCaso: any, changes :any, cancelarFirma: boolean = false)
  {

    return this.http.post<any>(`${this.principalURL}/case/update`, {idCaso, changes, cancelarFirma })
  }


  createReport(REPORTE: any)
  {
    return this.http.post<any>(`${this.principalURL}/report/create`, REPORTE)   
  }
  getReportByCase(CASO_ID: any)
  {
    return this.http.post<any>(`${this.principalURL}/report/caso`, {CASO_ID})   
  }
  updateUserTheme(theme: string) {
    return this.http.post<any>(`${this.principalURL}/auth/updateTheme`, {theme});
  }

  getToken(){
    return localStorage.getItem('token')
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  refreshToken(): Observable<string> {
    const token = this.getToken();
    return this.http.post<{ jwtToken: string }>(`${this.principalURL}/auth/refresh`, {}, {
      headers: new HttpHeaders({ Authorization: 'Bearer ' + token })
    }).pipe(
      switchMap(response => {
        this.setToken(response.jwtToken);
        return response.jwtToken;
      })
    );
  }
  
  

  getUserStyle(): string | null {
    return localStorage.getItem('userStyle');
  }
  getRole() {
    return this.currentUserRole.asObservable();
    
  }

  getEmployee() {
    return this.http.get<any>(`${this.principalURL}/utils/employee`);
  }

  checkRoleFromLocalStorage() {
      const role = localStorage.getItem('role');
      if (role) {
          this.currentUserRole.next(role);
      }
  }

  setCotizacion(COTIZACION: any)
  {
    return this.http.post<any>(`${this.principalURL}/case/cotizacion`, COTIZACION)   
  }

  loginAs(empleadoId: number) {
    return this.http.post<{ jwtToken: string }>(`${this.principalURL}/auth/login-as`, { empleadoId });
  }

  
  saveToken(token: string) {
    localStorage.setItem('token', token);
  }

  restoreOriginalSession() {
    localStorage.removeItem('token');
    // Puedes guardar el token original antes de hacer login-as
    const originalToken = localStorage.getItem('originalToken');
    if (originalToken) {
        this.saveToken(originalToken);
        localStorage.removeItem('originalToken');
        window.location.reload();
    } else {
        // Si no, simplemente hace logout
        this.logOutUser();
    }
}

getEmployeeIdFromToken(): number | null {
  const token = localStorage.getItem('token'); // 👈 CORREGIDO: era 'jwtToken'
  if (!token) return null;

  try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.EMPLEADO_ID;
  } catch (e) {
      console.error('Error leyendo token:', e);
      return null;
  }
}

getRolIdFromToken(): number | null {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.rol ?? null;
  } catch (e) {
      return null;
  }
}

getCurrentUserNameFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.userNomC || null;
  } catch (e) {
      console.error('Error leyendo token:', e);
      return null;
  }
}



}
